import React from "react";
import { Box } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";
import { checkUserDetailsFromCookie } from "../../api_calls/userManagement";
import { resetListingCaches } from "../../api_calls/utils";
import { useDispatch } from "react-redux";
import { resetBrandReportView } from "../../api_calls/utils";
import Dashboard from "../../components/commonComponents/Embeddable/Dashboard";
import { deleteItems } from "../../Store/actions";

const FerreroDashboard = () => {
  const [userInfo, setUserInfo] = React.useState({});
  const dispatchAction = useDispatch();
  const EMBEDDABLE_DASHBOARD_ID = process.env.REACT_APP_ENV_NAME === 'demo'
  ? 'bebe4382-aad6-4deb-bec5-def7b6605f23'
  : '201d1b16-fdd6-4e26-99ab-d20c136d7fff';

  React.useEffect(() => {
    resetBrandReportView();
    resetListingCaches();
    const checkUserDetails = checkUserDetailsFromCookie();
    let userDetailObj = {};
    if (checkUserDetails.success === true) {
      userDetailObj = checkUserDetails.user_detail;
    }
    setUserInfo(userDetailObj);
    
    // Resetting store dates when the component unmounts
    return () => {
      dispatchAction(deleteItems(["store_dates"]));
    };
  }, []);

  return typeof userInfo.root_company_id !== "undefined" ? (
    <StyledMainBox component="main">
      {/* -------- embeddable dashboard -------- */}
      <Grid container spacing={2}>
        {typeof userInfo.root_company_id !== "undefined" && (
          <Dashboard
            embedDashboardId={EMBEDDABLE_DASHBOARD_ID}
            variables={{}}
            filterConfig={{
              "number_root": userInfo.root_company_id.toString(),
            }} />
        )}
      </Grid>
    </StyledMainBox>
  ) : (
    <></>
  );
};

export default AccessControl(FerreroDashboard, ["overview_can_view"], [], ["customDashboard"]);
